import React from 'react';

import { createPortal } from 'react-dom';
import classNames from 'classnames';

import useUnmountWithDelay from '../../hooks/useUnmountWithDelay';

export default function DialogModal({
  children,
  isVisible,
  hideModal,
  title,
  zIndex,
}) {
  const isModalContentMounted = useUnmountWithDelay({
    shouldBeMounted: isVisible,
    delay: 300,
  });

  return createPortal(
    <>
      <div
        style={{ zIndex }}
        className={classNames('fixed inset-0 z-50 bg-black', {
          'opacity-0 pointer-events-none': !isVisible,
          'opacity-50 pointer-events-auto': isVisible,
        })}
      />
      <div
        tabIndex="-1"
        aria-hidden="true"
        style={{ zIndex }}
        className={classNames(
          'overflow-y-auto overflow-x-hidden fixed inset-0 z-50 justify-center items-center w-full md:inset-0 h-modal md:h-full flex transition-all',
          {
            'opacity-100 pointer-events-auto translate-y-0 scale-100 md:scale-100':
              isVisible,
            'opacity-0 pointer-events-none -translate-y-1/12 scale-60 md:scale-100':
              !isVisible,
          }
        )}
      >
        <div className="relative p-4 h-full md:h-auto">
          <div className="relative p-4 bg-white rounded-lg shadow dark:bg-gray-800 sm:p-5">
            <header className="text-center">
              <button
                type="button"
                className="text-gray-400 absolute top-2.5 right-2.5 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                onClick={hideModal}
              >
                <svg
                  aria-hidden="true"
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
              <h3 className="mb-2 text-lg font-semibold text-gray-900 dark:text-white">
                {title}
              </h3>
            </header>

            <div className="max-w-[calc(100vw-4rem)] w-[calc(100vw-4rem)] sm:w-auto">
              {isModalContentMounted && children}
            </div>
          </div>
        </div>
      </div>
    </>,
    document.body
  );
}
